var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-subheader',[_c('v-tooltip',{attrs:{"bottom":"","max-width":"400px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('span',_vm._g(_vm._b({},'span',attrs,false),on),[_vm._v(" "+_vm._s(_vm.label)+" ")])]}}])},[_c('p',[_c('vue-markdown',{attrs:{"breaks":false,"source":_vm.docs}})],1)])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }